import { useParams } from 'react-router-dom'
import UserForm from './UserForm'

const View = () => {
    const params = useParams()

    return (
        <UserForm
            inPopup={false}
            id={parseInt(params.userId)}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'User updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update user',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating user...',
                },
            }}
        />
    )
}

export default View
